import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";
import { useRoute } from "vue-router";
const urlPathName = window?.location?.hash?.split("/");
const type = urlPathName[3];
const kataKata = type?.split("-");
const title = kataKata?.map(function (kata) {
  return kata?.charAt(0)?.toUpperCase() + kata?.slice(1)?.toLowerCase();
});
const title_pembayaran = title?.join(" ");
const title_page =
  title_pembayaran === "Tabungan Thr" ? "Tabungan THR" : title_pembayaran;
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "Dashboard",
        },
      },
      {
        path: "/transaksi",
        name: "view-transaksi",
        component: () => import("@/views/transaksi/List.vue"),
        meta: {
          pageTitle: "Transaksi",
        },
      },
      {
        path: "/users",
        name: "view-user",
        component: () => import("@/views/users/Index.vue"),
        meta: {
          pageTitle: "Management Users",
        },
      },
      {
        path: "/user/edit/:id",
        name: "edit-user",
        component: () => import("@/views/users/Form.vue"),
        meta: {
          pageTitle: "Edit User",
          breadcrumbs: [{ title: "Management Users" }],
        },
      },
      {
        path: "/user/create",
        name: "create-user",
        component: () => import("@/views/users/Form.vue"),
        meta: {
          pageTitle: "Create User",
          breadcrumbs: [{ title: "Management Users" }],
        },
      },
      {
        path: "/transaksi",
        name: "transaksi",
        children: [],
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/profile/Account.vue"),
        meta: {
          pageTitle: "Profile",
        },
        children: [
          {
            path: "overview",
            name: "profile-overview",
            component: () => import("@/views/profile/Overview.vue"),
            meta: {
              pageTitle: "Overview",
            },
          },
          {
            path: "settings",
            name: "profile-settings",
            component: () => import("@/views/profile/Settings.vue"),
            meta: {
              pageTitle: "Settings",
            },
          },
        ],
      },
      {
        path: "/content/banner",
        name: "view-banner",
        component: () => import("@/views/content/banner/List.vue"),
        meta: {
          pageTitle: "Banner",
        },
      },
      {
        path: "/content/banner/create",
        name: "create-banner",
        component: () => import("@/views/content/banner/Form.vue"),
        meta: {
          pageTitle: "Tambah Banner",
          breadcrumbs: [{ title: "Banner", to: "/content/banner" }],
        },
      },
      {
        path: "/content/banner/edit/:id",
        name: "edit-banner",
        component: () => import("@/views/content/banner/Form.vue"),
        meta: {
          pageTitle: "Ubah Banner",
          breadcrumbs: [{ title: "Banner", to: "/content/banner" }],
        },
      },
      {
        path: "/content/banner/detail/:id",
        name: "detail-banner",
        component: () => import("@/views/content/banner/Detail.vue"),
        meta: {
          pageTitle: "Detail Banner",
          breadcrumbs: [{ title: "Banner", to: "/content/banner" }],
        },
      },
      {
        path: "/content/home-section",
        name: "view-home-section",
        component: () => import("@/views/content/home-section/List.vue"),
        meta: {
          pageTitle: "Home Section",
        },
      },
      {
        path: "/content/home-section/create",
        name: "create-home-section",
        component: () => import("@/views/content/home-section/Form.vue"),
        meta: {
          pageTitle: "Tambah Home Section",
          breadcrumbs: [{ title: "Home Section", to: "/content/home-section" }],
        },
      },
      {
        path: "/content/home-section/set-program/:id",
        name: "set-program-home-section",
        component: () => import("@/views/content/home-section/Detail.vue"),
        meta: {
          pageTitle: "Atur Program Home Section",
          breadcrumbs: [{ title: "Home Section", to: "/content/home-section" }],
        },
      },
      {
        path: "/content/home-section/edit/:id",
        name: "edit-home-section",
        component: () => import("@/views/content/home-section/Form.vue"),
        meta: {
          pageTitle: "Ubah Home Section",
          breadcrumbs: [{ title: "Home Section", to: "/content/home-section" }],
        },
      },
      {
        path: "/content/home-section/detail/:id",
        name: "detail-home-section",
        component: () => import("@/views/content/home-section/Detail.vue"),
        meta: {
          pageTitle: "Detail Home Section",
          breadcrumbs: [{ title: "Home Section", to: "/content/home-section" }],
        },
      },
      {
        path: "/trainer/list",
        name: "view-trainer",
        component: () => import("@/views/trainer/List.vue"),
        meta: {
          pageTitle: "Trainer",
        },
      },
      {
        path: "/trainer/list/step-1",
        name: "create-trainer",
        component: () => import("@/views/trainer/step/step-1.vue"),
        meta: {
          pageTitle: "Tambah Personal Data Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/step-2",
        name: "create-pendidikan-trainer",
        component: () => import("@/views/trainer/step/step-2.vue"),
        meta: {
          pageTitle: "Tambah Pendidikan Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/pendidikan/create",
        name: "create-pendidikan",
        component: () => import("@/views/trainer/create-edit/Pendidikan.vue"),
        meta: {
          pageTitle: "Tambah Pendidikan Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/step-3",
        name: "create-pengalaman-trainer",
        component: () => import("@/views/trainer/step/step-3.vue"),
        meta: {
          pageTitle: "Tambah Pengalaman Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/pengalaman/create",
        name: "create-pengalaman",
        component: () => import("@/views/trainer/create-edit/Pengalaman.vue"),
        meta: {
          pageTitle: "Tambah Pengalaman Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/step-4",
        name: "create-sertifikat-trainer",
        component: () => import("@/views/trainer/step/step-4.vue"),
        meta: {
          pageTitle: "Tambah Sertifikat Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/sertifikat/create",
        name: "create-sertifikat",
        component: () => import("@/views/trainer/create-edit/Sertifikat.vue"),
        meta: {
          pageTitle: "Tambah Sertifikat Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/step-5",
        name: "create-portfolio-trainer",
        component: () => import("@/views/trainer/step/step-5.vue"),
        meta: {
          pageTitle: "Tambah Portfolio Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/portfolio/create",
        name: "create-portfolio",
        component: () => import("@/views/trainer/create-edit/Portofolio.vue"),
        meta: {
          pageTitle: "Tambah Portofolio Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/edit",
        name: "edit-trainer",
        component: () => import("@/views/trainer/create-edit/Form.vue"),
        meta: {
          pageTitle: "Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/edit/:id/pendidikan",
        name: "edit-trainer-pendidikan",
        component: () => import("@/views/trainer/create-edit/Pendidikan.vue"),
        meta: {
          pageTitle: "Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/edit/:id/sertifikat",
        name: "edit-trainer-sertifikat",
        component: () => import("@/views/trainer/create-edit/Sertifikat.vue"),
        meta: {
          pageTitle: "Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/edit/:id/pengalaman",
        name: "edit-trainer-pengalaman",
        component: () => import("@/views/trainer/create-edit/Pengalaman.vue"),
        meta: {
          pageTitle: "Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:slug/edit/:id/portfolio",
        name: "edit-trainer-portfolio",
        component: () => import("@/views/trainer/create-edit/Portofolio.vue"),
        meta: {
          pageTitle: "Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:id/general-info",
        name: "detail-trainer",
        component: () => import("@/views/trainer/detail/Detail.vue"),
        meta: {
          pageTitle: "General Info Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:id/general-info-pendidikan",
        name: "detail-trainer-pendidikan",
        component: () => import("@/views/trainer/detail/DetailPendidikan.vue"),
        meta: {
          pageTitle: "General Info Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:id/general-info-pengalaman",
        name: "detail-trainer-pengalaman",
        component: () => import("@/views/trainer/detail/DetailPengalaman.vue"),
        meta: {
          pageTitle: "General Info Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:id/general-info-sertifikat",
        name: "detail-trainer-sertifikat",
        component: () => import("@/views/trainer/detail/DetailSertifikat.vue"),
        meta: {
          pageTitle: "General Info Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/list/:id/general-info-portofolio",
        name: "detail-trainer-portofolio",
        component: () => import("@/views/trainer/detail/DetailPortofolio.vue"),
        meta: {
          pageTitle: "General Info Trainer",
          breadcrumbs: [{ title: "Trainer", to: "/trainer" }],
        },
      },
      {
        path: "/trainer/pengajuan-trainer",
        name: "view-pengajuan-trainer",
        component: () => import("@/views/trainer/pengajuan/List.vue"),
        meta: {
          pageTitle: "Pengajuan Trainer",
        },
      },
      {
        path: "/trainer/provider",
        name: "view-trainer-provider",
        component: () => import("@/views/trainer/provider/List.vue"),
        meta: {
          pageTitle: "Trainer Provider",
        },
      },
      {
        path: "/trainer/provider/create",
        name: "create-trainer-provider",
        component: () => import("@/views/trainer/provider/Form.vue"),
        meta: {
          pageTitle: "Tambah Trainer Provider",
          breadcrumbs: [{ title: "Trainer Provider", to: "/trainer/provider" }],
        },
      },
      {
        path: "/trainer/provider/edit/:id",
        name: "edit-trainer-provider",
        component: () => import("@/views/trainer/provider/Form.vue"),
        meta: {
          pageTitle: "Ubah Trainer Provider",
          breadcrumbs: [{ title: "Trainer Provider", to: "/trainer/provider" }],
        },
      },
      {
        path: "/trainer/provider/detail/:id",
        name: "detail-trainer-provider",
        component: () => import("@/views/trainer/provider/Detail.vue"),
        meta: {
          pageTitle: "Detail Trainer Provider",
          breadcrumbs: [{ title: "Trainer Provider", to: "/trainer/provider" }],
        },
      },
      {
        path: "/program/list",
        name: "view-program",
        component: () => import("@/views/program/List.vue"),
        meta: {
          pageTitle: "Program",
        },
      },
      {
        path: "/program/list/create",
        name: "create-program",
        component: () => import("@/views/program/Form.vue"),
        meta: {
          pageTitle: "Program",
          breadcrumbs: [
            { title: "Program" },
            { title: "Program", to: "/program" },
          ],
        },
      },
      {
        path: "/program/list/edit/:id",
        name: "edit-program",
        component: () => import("@/views/program/Form.vue"),
        meta: {
          pageTitle: "Program",
          breadcrumbs: [
            { title: "Program" },
            { title: "Program", to: "/program" },
          ],
        },
      },
      {
        path: "/program/list/detail/:id",
        name: "detail-program",
        component: () => import("@/views/program/Detail.vue"),
        meta: {
          pageTitle: "Program",
          breadcrumbs: [
            { title: "Program" },
            { title: "Program", to: "/program" },
          ],
        },
      },
      {
        path: "/program/list/module",
        name: "view-program-module",
        component: () => import("@/views/program/List.vue"),
        meta: {
          pageTitle: "Program",
        },
      },
      {
        path: "/program/list/:slug/create-module",
        name: "create-program-module",
        component: () => import("@/views/program/FormModule.vue"),
        meta: {
          pageTitle: "Program",
          breadcrumbs: [{ title: "Program", to: "/program" }],
        },
      },
      {
        path: "/program/list/:slug/edit-module",
        name: "edit-program-module",
        component: () => import("@/views/program/FormModule.vue"),
        meta: {
          pageTitle: "Program",
          breadcrumbs: [{ title: "Program", to: "/program" }],
        },
      },
      {
        path: "/program/list/:slug/detail-module",
        name: "detail-program-module",
        component: () => import("@/views/program/DetailModule.vue"),
        meta: {
          pageTitle: "Program Module",
          breadcrumbs: [
            { title: "Program Module" },
            { title: "Program", to: "/program" },
          ],
        },
      },
      {
        path: "/program/list/:id/detail-batch",
        name: "detail-program-batch",
        component: () => import("@/views/program/DetailBatch.vue"),
        meta: {
          pageTitle: "Program Batch",
          breadcrumbs: [
            { title: "Program Batch" },
            { title: "Program", to: "/program" },
          ],
        },
      },
      {
        path: "/program/list/:id/detail-link-materi",
        name: "detail-program-link-materi",
        component: () => import("@/views/program/DetailMateri.vue"),
        meta: {
          pageTitle: "Program Link Materi",
          breadcrumbs: [
            { title: "Program Link Materi" },
            { title: "Program", to: "/program" },
          ],
        },
      },
      {
        path: "/program/kategori",
        name: "view-program-category",
        component: () => import("@/views/program/kategori/List.vue"),
        meta: {
          pageTitle: "Program Kategori",
        },
      },
      {
        path: "/program/kategori/create",
        name: "create-program-category",
        component: () => import("@/views/program/kategori/Form.vue"),
        meta: {
          pageTitle: "Program Kategori",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Kategori", to: "/program/kategori" },
          ],
        },
      },
      {
        path: "/program/kategori/edit/:id",
        name: "edit-program-category",
        component: () => import("@/views/program/kategori/Form.vue"),
        meta: {
          pageTitle: "Program Kategori",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Kategori", to: "/program/kategori" },
          ],
        },
      },
      {
        path: "/program/kategori/detail/:id",
        name: "detail-program-category",
        component: () => import("@/views/program/kategori/Detail.vue"),
        meta: {
          pageTitle: "Program Kategori",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Kategori", to: "/program/kategori" },
          ],
        },
      },
      {
        path: "/program/batch",
        name: "view-program-batch",
        component: () => import("@/views/program/batch/List.vue"),
        meta: {
          pageTitle: "Program Jadwal",
        },
      },
      {
        path: "/program/batch/create",
        name: "create-program-batch",
        component: () => import("@/views/program/batch/Form.vue"),
        meta: {
          pageTitle: "Program Jadwal",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Jadwal", to: "/program/batch" },
          ],
        },
      },
      {
        path: "/program/batch/edit/:id",
        name: "edit-program-batch",
        component: () => import("@/views/program/batch/Form.vue"),
        meta: {
          pageTitle: "Program Jadwal",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Jadwal", to: "/program/batch" },
          ],
        },
      },
      {
        path: "/program/batch/detail/:id",
        name: "detail-program-jadwal",
        component: () => import("@/views/program/batch/Detail.vue"),
        meta: {
          pageTitle: "Program Jadwal",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Jadwal", to: "/program/batch" },
          ],
        },
      },
      {
        path: "/program/batch/partisipan/:id",
        name: "detail-program-jadwal-partisipan",
        component: () => import("@/views/program/batch/DetailPartisipan.vue"),
        meta: {
          pageTitle: "Program Jadwal Partisipan",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Jadwal", to: "/program/batch" },
          ],
        },
      },
      {
        path: "/program/batch/upload-sertifikat/:id",
        name: "upload-sertifikat-program-jadwal",
        component: () => import("@/views/program/batch/UploadSertifikat.vue"),
        meta: {
          pageTitle: "Program Jadwal",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Jadwal", to: "/program/upload-sertifikat" },
          ],
        },
      },
      {
        path: "/program/template-form-peserta",
        name: "view-program-template-form-peserta",
        component: () =>
          import("@/views/program/template-form-peserta/List.vue"),
        meta: {
          pageTitle: "Template Form Peserta",
        },
      },
      {
        path: "/program/template-form-peserta/create",
        name: "create-program-template-form-peserta",
        component: () =>
          import("@/views/program/template-form-peserta/Form.vue"),
        meta: {
          pageTitle: "Template Form Peserta",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            {
              title: "Template Form Peserta",
              to: "/program/template-form-peserta",
            },
          ],
        },
      },
      {
        path: "/program/template-form-peserta/edit/:id",
        name: "edit-program-template-form-peserta",
        component: () =>
          import("@/views/program/template-form-peserta/Form.vue"),
        meta: {
          pageTitle: "Template Form Peserta",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            {
              title: "Template Form Peserta",
              to: "/program/template-form-peserta",
            },
          ],
        },
      },
      {
        path: "/program/template-form-peserta/detail/:id",
        name: "detail-program-template-form-peserta",
        component: () =>
          import("@/views/program/template-form-peserta/Detail.vue"),
        meta: {
          pageTitle: "Template Form Peserta",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            {
              title: "Template Form Peserta",
              to: "/program/template-form-peserta",
            },
          ],
        },
      },
      {
        path: "/program/voucer-diskon",
        name: "view-program-voucer-diskon",
        component: () => import("@/views/program/voucer-diskon/List.vue"),
        meta: {
          pageTitle: "Program Voucer Diskon",
        },
      },
      {
        path: "/program/voucer-diskon/create",
        name: "create-program-voucer-diskon",
        component: () => import("@/views/program/voucer-diskon/Form.vue"),
        meta: {
          pageTitle: "Program Voucer Diskon",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Voucer Diskon", to: "/program/voucer-diskon" },
          ],
        },
      },
      {
        path: "/program/voucer-diskon/edit/:id",
        name: "edit-program-voucer-diskon",
        component: () => import("@/views/program/voucer-diskon/Form.vue"),
        meta: {
          pageTitle: "Program Voucer Diskon",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Voucer Diskon", to: "/program/voucer-diskon" },
          ],
        },
      },
      {
        path: "/program/voucer-diskon/detail/:id",
        name: "detail-program-voucer-diskon",
        component: () => import("@/views/program/voucer-diskon/Detail.vue"),
        meta: {
          pageTitle: "Program Voucer Diskon",
          breadcrumbs: [
            { title: "Program", to: "/program" },
            { title: "Voucer Diskon", to: "/program/voucer-diskon" },
          ],
        },
      },
      {
        path: "/master/profession",
        name: "view-master-profesi",
        component: () => import("@/views/master/profesi/List.vue"),
        meta: {
          pageTitle: "Data Master Profesi",
        },
      },
      {
        path: "/master/profession/create",
        name: "create-master-profesi",
        component: () => import("@/views/master/profesi/Form.vue"),
        meta: {
          pageTitle: "Data Master Profesi",
          breadcrumbs: [
            { title: "Data Master Profesi", to: "/master/profession" },
          ],
        },
      },
      {
        path: "/master/profession/edit/:id",
        name: "edit-master-profesi",
        component: () => import("@/views/master/profesi/Form.vue"),
        meta: {
          pageTitle: "Data Master Profesi",
          breadcrumbs: [
            { title: "Data Master Profesi", to: "/master/profession" },
          ],
        },
      },
      {
        path: "/master/profession/detail/:id",
        name: "detail-master-profesi",
        component: () => import("@/views/master/profesi/Detail.vue"),
        meta: {
          pageTitle: "Data Master Profesi",
          breadcrumbs: [
            { title: "Data Master Profesi", to: "/master/profession" },
          ],
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () => import("@/views/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Sign In",
        },
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () => import("@/views/authentication/basic-flow/SignUp.vue"),
        meta: {
          pageTitle: "Sign Up",
        },
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/authentication/basic-flow/PasswordReset.vue"),
        meta: {
          pageTitle: "Password reset",
        },
      },
    ],
  },
  {
    path: "/multi-step-sign-up",
    name: "multi-step-sign-up",
    component: () => import("@/views/authentication/MultiStepSignUp.vue"),
    meta: {
      pageTitle: "Multi-step Sign up",
    },
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/authentication/Error404.vue"),
        meta: {
          pageTitle: "Error 404",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/authentication/Error500.vue"),
        meta: {
          pageTitle: "Error 500",
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // current page view title
  document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_NAME}`;

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // verify auth token before each page change
  //store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  // get profile before each page change
  store.dispatch(Actions.GET_PROFILE, {
    api_token: JwtService.getToken(),
  });

  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    if (store.getters.isUserAuthenticated) {
      next();
    } else {
      next({ name: "sign-in" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;
